<div class="sharesHeaders__flags" ppTooltip [ppTitle]="ppDisabled ? disabledTooltipText : ''">
  <pp-toggle
    [ppDisabled]="ppDisabled"
    [ppChecked]="editPermission"
    (ppAction)="changeEditPermission()"
    ppStyle="blue"
  ></pp-toggle>
</div>
